import { IntegrationCategoryStatusInfo } from "../../../../models/Entities";
import { INTEGRATION_CATEGORY_STATUSES } from "../../../../constants";

export const getCategoryStatusTextInfo = (statusInfo: IntegrationCategoryStatusInfo) => {
  switch (statusInfo.status) {
    case INTEGRATION_CATEGORY_STATUSES.ACTIVE:
      return {
        statusText: "Active",
      };
    case INTEGRATION_CATEGORY_STATUSES.IN_BETA:
      return {
        statusText: "Beta",
      };
    case INTEGRATION_CATEGORY_STATUSES.DRAFT:
      return {
        statusText: "Draft",
      };
    default:
      return {
        statusText: "Inactive",
      };
  }
};

export const isCategoryStatusBeta = (statusInfo: IntegrationCategoryStatusInfo): boolean => {
  return statusInfo.status === INTEGRATION_CATEGORY_STATUSES.IN_BETA;
};

export const isCategoryStatusDraft = (statusInfo: IntegrationCategoryStatusInfo): boolean => {
  return statusInfo.status === INTEGRATION_CATEGORY_STATUSES.DRAFT;
};

export const isCategoryStatusInactive = (statusInfo: IntegrationCategoryStatusInfo): boolean => {
  return (
    statusInfo.status !== INTEGRATION_CATEGORY_STATUSES.ACTIVE &&
    statusInfo.status !== INTEGRATION_CATEGORY_STATUSES.IN_BETA
  );
};

export const isCategoryStatusActiveOrBeta = (
  statusInfo: IntegrationCategoryStatusInfo
): boolean => {
  return (
    statusInfo.status === INTEGRATION_CATEGORY_STATUSES.IN_BETA ||
    statusInfo.status === INTEGRATION_CATEGORY_STATUSES.ACTIVE
  );
};
